import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';

@Component({
    selector: 'app-amlbotaudit',
    templateUrl: './amlbotaudit.component.html',
    styleUrls: ['./amlbotaudit.component.css']
})
export class AMLBotAuditComponent implements OnInit {
    filter: any = {
        fromDate: moment().format('yyyy-MM-DD'),
        toDate: moment().format('yyyy-MM-DD')
    };
    displayedColumns = [
        'data',
        'asset',
        'network',
        'status',
        'hasBlackListFlag',
        'uid',
        'riskScore',
        'promoFlow',
        'discountDueTime',
        'discount',
        'amlFlow',
        'balance',
        'result',
        'description',
        'createdAt',
    ];
    public dataSource: any = new MatTableDataSource();
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.applyRefreshData();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['fromDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['toDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.userService.getAllAMLBotAudit(this.filter).subscribe((success) => {
                let AMLBotAuditRes = success.map(amlbotAudit => {
                    amlbotAudit.isData = amlbotAudit.data ? true : false;
                    amlbotAudit.createdAt = moment(amlbotAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return amlbotAudit;
                })
                this.dataSource = new MatTableDataSource(AMLBotAuditRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: JSON.parse(JSON.stringify(jsonData)),
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const amlbot_audit = await this.dataSource.filteredData.map(x => ({
                'asset': x.asset,
                'network': x.network,
                'status': x.status,
                'hasBlackListFlag': x.hasBlackListFlag,
                'uid': x.uid,
                'riskScore': x.riskScore,
                'promoFlow': x.promoFlow,
                'discountDueTime': x.discountDueTime,
                'discount': x.discount,
                'amlFlow': x.amlFlow,
                'balance': x.balance,
                'result': x.result,
                'createdAt': x.createdAt
            }));
            TableUtil.exportArrayToExcel(amlbot_audit, "AMLBot Audit Report");
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/amlbotaudit/amlbotaudit.component.ts